ScoreTrekBattle.League = ScoreTrekBattle.League || {};
ScoreTrekBattle.League.ClubMatchdays = (function() {
    var _this, CONFIG, STATUS, CACHE;

    CONFIG = {
        CACHE_SIZE: 5
    };

    CACHE = ListState.create(CONFIG.CACHE_SIZE);

    function resetStatus() {
        STATUS = {
            active: false,
            clubId: null,
            seasonId: '',
            hasSeasons: false,
            isShown: false,
            renderId: 0,
            view: null,
            $view: null,
            $list: null,
            CURRENT: null
        };

        ScoreTrekBattle.Club.setCurrent(null);
    }
    resetStatus();

    function onViewRender(clubId, seasonId) {
        return new Promise(function(resolve) {
            STATUS.clubId = clubId || null;
            STATUS.seasonId = seasonId || '';

            ScoreTrekBattle.View.updateMenu('/league/matchdays');
            ScoreTrekBattle.Template.render('club/matchdays', {
                clubId: STATUS.clubId || ''
            }).then(view => {
                STATUS.active = true;
                STATUS.view = view;
                STATUS.$view = view.$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                STATUS.$view.find('[data-tab="matchdays"]').addClass('isActive');

                STATUS.view.controls.seasonId.on('change', function() {
                    selectSeason(this.get());
                });

                resolve(STATUS.$view);
            });
        });
    }

    function onViewLoad() {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateClub().then(() => {
                updateList();
            }).catch(ignore => {}).finally(() => {
                resolve();
            });
        });
    }

    function onViewUpdate(clubId, seasonId) {
        return new Promise(function(resolve) {
            if (STATUS.$list && (clubId === STATUS.clubId) && seasonId && (seasonId !== STATUS.seasonId)) {
                STATUS.view.controls.seasonId.set(seasonId);
                selectSeason(seasonId);
            }
            resolve();
        });
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            if (STATUS.CURRENT) {
                STATUS.CURRENT.scrollTop = AnimationHandler.getScrollTop();
            }

            resetStatus();
            resolve();
        });
    }

    function selectSeason(seasonId) {
        if (!seasonId || (seasonId === STATUS.seasonId)) {
            return;
        }

        STATUS.seasonId = seasonId;
        ScoreTrekBattle.View.setPath(buildPath());
        updateList();
    }

    function buildPath() {
        return `/club/matchdays/${STATUS.clubId}${STATUS.seasonId ? `/${STATUS.seasonId}` : ''}`;
    }

    function updateClub() {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.loading('League.ClubMatchdays.updateClub', true);

            ScoreTrekBattle.Club.load(STATUS.clubId).then(club => {
                ScoreTrekBattle.Club.setCurrent(club);

                ScoreTrekBattle.Template.render('tournament/details/club', {
                    club: club,
                    clubEscaped: ScoreTrekBattle.Club.escape(club),
                    mapsUrl: ScoreTrekBattle.Club.getMapsUrl(club)
                }).then(view => {
                    STATUS.$view.attr({
                        'data-club-id': club.id,
                        'data-club-is-favorite': club.isFavorite ? 'yes' : 'no'
                    });

                    STATUS.$view.find('[data-tab="tournaments"]').attr('href', `/club/tournaments/${club.id}`);
                    STATUS.$view.find('[data-tab="series"]').attr('href', `/club/series/${club.id}`);
                    STATUS.$view.find('[data-tab="matchdays"]').attr('href', `/club/matchdays/${club.id}`);

                    STATUS.$view.find('[data-id="clubDetails"]').append(view.$view);

                    ['email', 'phone', 'website'].forEach(field => {
                        if (!club[field]) {
                            STATUS.$view.find(`[data-id="club.${field}"]`).remove();
                        }
                    });

                    STATUS.$view.find('[data-id="club.hiddenTournaments"]').remove();

                    resolve();
                });
            }).catch(error => {
                ScoreTrekBattle.View.goto('/dashboard').then(() => {
                    setTimeout(() => {
                        chmDialog.error(error);
                    }, 0);
                });
                reject();
            }).finally(() => {
                ScoreTrekBattle.View.loading('League.ClubMatchdays.updateClub', false);
            });
        });
    }

    function updateSeasons(seasons, seasonId) {
        let control, hadSeason;

        control = STATUS.view.controls.seasonId;

        if (!STATUS.hasSeasons) {
            STATUS.hasSeasons = true;
            control.setOptions(DataHandler.arrayToOptions(seasons, 'id', 'name'));
            STATUS.$view.find('[data-id="seasonSelector"]').toggleClass('hide', seasons.length === 0);
        }

        if (seasonId !== STATUS.seasonId) {
            hadSeason = (STATUS.seasonId !== '');
            STATUS.seasonId = seasonId;

            if (hadSeason) {
                ScoreTrekBattle.View.setPath(buildPath());
            }
        }

        control.set(seasonId);
    }

    function updateList() {
        let clubId, seasonId, cacheItem, hasCache, loadingId;

        clubId = STATUS.clubId;
        seasonId = STATUS.seasonId;
        cacheItem = CACHE.get(`${clubId}:${seasonId}`);
        STATUS.CURRENT = cacheItem;
        STATUS.isShown = false;
        hasCache = !!cacheItem.items;
        loadingId = 'League.ClubMatchdays.updateList';

        if (hasCache) {
            showResult(cacheItem, cacheItem.items);
        } else {
            STATUS.$list.addClass('loading');
        }

        ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, true);

        Api.request('/battle/league/matchday/clubList', {
            clubId: clubId,
            seasonId: seasonId
        }).then(result => {
            let data;

            if (!STATUS.$list || (STATUS.CURRENT !== cacheItem)) {
                return;
            }

            data = {
                seasons: result.seasons || [],
                seasonId: result.seasonId || '',
                list: result.list || []
            };

            if (hasCache && ListState.isEqual(data, cacheItem.items)) {
                return;
            }

            cacheItem.items = data;

            return showResult(cacheItem, data);
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            if (STATUS.$list) {
                STATUS.$list.removeClass('loading');
            }
            ScoreTrekBattle.View[hasCache ? 'loadingBackground' : 'loading'](loadingId, false);
        });
    }

    function showResult(cacheItem, data) {
        let renderId;

        renderId = ++STATUS.renderId;

        updateSeasons(data.seasons, data.seasonId);

        return renderList(data.list).then($items => {
            if (!STATUS.$list || (STATUS.CURRENT !== cacheItem) || (renderId !== STATUS.renderId)) {
                return;
            }

            STATUS.$list.empty().append($items);

            if (!STATUS.isShown) {
                STATUS.isShown = true;
                ListState.restoreScrollTop(STATUS.$view, cacheItem.scrollTop);
            }
        });
    }

    function renderList(items) {
        if (items.length > 0) {
            return ScoreTrekBattle.League.Matchdays.renderList(items);
        }

        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render('club/matchdaysItemEmpty', {}, true).then(itemView => {
                resolve([itemView.$view]);
            });
        });
    }

    _this = {
        getShareHash: function() {
            return STATUS.$view ? buildPath() : null;
        }
    };

    ScoreTrekBattle.View.register('/club/matchdays', onViewRender, onViewLoad, onViewUpdate, onViewUnload);

    return _this;
})();
